"use client";

import Image from "next/image";

type Props = {
  image: string;        // UNA sola immagine
  className?: string;
};

export default function FullscreenImageViewer({
  image,
  className = "",
}: Props) {
  return (
    <div className={`w-full h-full flex items-center justify-center ${className}`}>
      <div className="relative w-full h-full max-w-[1000px] max-h-[80dvh]">
        <Image
          src={image}
          alt="Immagine"
          fill
          className="object-contain"
          sizes="100vw"
          priority
        />
      </div>
    </div>
  );
}